/**
 * Utility function used to merge CSS classes together.
 * Often referenced as: `import { cn } from "@/lib/utils"` in shadcn docs.
 */
export function mergeCSSClasses(...classes: (string | undefined | false)[]) {
  return classes.filter(Boolean).join(' ');
}
